/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import MainLayout from 'components/layouts/main'
import { DuplicateNFTsList, DuplicateNFTsFilter } from 'features'

import { DuplicateNFTsSelector, DuplicateNFTsTypes } from 'store'
import { getDuplicateNFTs } from 'services'

const DuplicateNFTsPage = () => {
  const {
    collections = [],
    isRequesting,
    hasDataToLoad,
    orderRef,
    order,
    activeChain,
  } = useSelector(DuplicateNFTsSelector)

  const dispatch = useDispatch()

  /**
   * This effect will run if there is a
   * changes happen on active chain
   */
  useEffect(() => {
    getCollections({
      displayLoader: true,
    })
  }, [activeChain])

  const getCollections = async ({ displayLoader = true }: any) => {
    console.log('getCollections start')
    if (isRequesting || !hasDataToLoad) {
      return false
    }

    console.log('dispatch DuplicateNFTsTypes.GET_DUPLICATE_NFTS_DATA')
    dispatch({
      type: DuplicateNFTsTypes.GET_DUPLICATE_NFTS_DATA,
      payload: { loading: displayLoader },
    })

    console.log('response = await getDuplicateNFTs')
    const response = await getDuplicateNFTs({
      orderRef,
      order,
      chain: activeChain,
    })

    console.log(' if (response.success)')
    if (response.success) {
      const loadMore = response.data.length > 0 ? true : false
      console.log('inside  if (response.success)')
      dispatch({
        type: DuplicateNFTsTypes.SET_DUPLICATE_NFTS_DATA,
        payload: {
          collections: response.data,
          hasDataToLoad: loadMore,
        },
      })
      console.log('dispatch  DuplicateNFTsTypes.SET_DUPLICATE_NFTS_DATA')
    }
  }

  const loadMoreData = () => {
    getCollections({
      displayLoader: true,
    })
  }

  return (
    <React.Fragment>
      <MainLayout>
        <div className='bg-white'>
          <h1 className='font-bold text-4xl text-center py-10 md:text-left lg:text-left md:px-6 lg:px-6'>
            Duplicate NFT Collections Dashboard
          </h1>

          <DuplicateNFTsFilter />

          <DuplicateNFTsList
            {...{
              collections,
              isRequesting,
              hasDataToLoad,
            }}
            onLoadMore={loadMoreData}
          />
        </div>
      </MainLayout>
    </React.Fragment>
  )
}

export default DuplicateNFTsPage
